import Actions from './Actions';

const noop = () => null;

const stagedAttachments = [
  {
    tempId: 'a',
    fileId: 'file-a',
    name: 'toimeksianto.pdf',
    size: 120000,
    progress: 100,
    state: 'available',
    error: null,
  },
  {
    tempId: 'b',
    fileId: null,
    name: 'brand-guidelines.zip',
    size: 5000000,
    progress: 42,
    state: 'uploading',
    error: null,
  },
];

const baseProps = {
  formId: 'ApplicationPanelActionsExample',
  transaction: { attributes: { protectedData: {} } },
  transactionId: 'application-tx',
  authorDisplayName: 'Joni V',
  onSubmit: values => console.log('submit with values:', values),
  onSkipApplication: noop,
  stagedAttachments,
  onUploadAttachment: file => console.log('upload attachment:', file.name),
  onRemoveAttachment: tempId => console.log('remove attachment:', tempId),
};

// The accept form opens after choosing "continue with applicant".
export const AcceptWithAttachments = {
  component: Actions,
  props: { ...baseProps, showActionButtons: true },
  group: 'transaction',
};

// Accepting an earlier skipped application: the message field is always shown.
export const AcceptAfterSkipWithAttachments = {
  component: Actions,
  props: { ...baseProps, showAcceptAfterSkipButton: true },
  group: 'transaction',
};
